import Actions from 'Actions';
const { TYPES } = Actions;

const initialState = { rvData: null, rvCategoryData: null };

const reducer = function (state = initialState, { type, payload }) {
    switch (type) {
        case TYPES.ADD_RV_DATA:
            return {
                ...state,
                rvData: payload
            };
        case TYPES.ADD_RV_CATEGORY_DATA:
            return {
                ...state,
                rvCategoryData: payload
            };
        default:
            return state;
    }
};

export default reducer;
